import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    allTemplates: string;
    addTemplate: string;
    clearSearch: string;
    dotSeparator: string;
    deleteConfirmationDialog: {
        /** Dialog title */
        title: string;
        /** Dialog details explaining deletion */
        details: string;
        /** Cancel button label */
        cancel: string;
        /** Delete button label */
        delete: string;
    };
    accessPreviouslyCreatedTemplates: string;
    nameEmailNotice: string;
    searchPending: string;
    searchPlaceholder: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for all templates filter */
            allTemplates: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateSelector.allTemplates?c=vsww7kn35dql", defaultMessage: "All Templates" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for add template button */
            addTemplate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateSelector.addTemplate?c=36g7iesxvaepv", defaultMessage: "Add Template" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for clearing the template search input text */
            clearSearch: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateSelector.clearSearch?c=37zab73t0k57l", defaultMessage: "Clear template search input" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dot separator character */
            dotSeparator: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateSelector.dotSeparator?c=337p58u7oqev9", defaultMessage: "\u2022" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Delete confirmation dialog text */
            deleteConfirmationDialog: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Dialog title */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateSelector.deleteConfirmationDialog.title?c=19ce8f3gn71a4", defaultMessage: "Delete template?" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Dialog details explaining deletion */
                        details: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateSelector.deleteConfirmationDialog.details?c=3j8vz0m2jh03y", defaultMessage: "Deletion is permanent, but this template will still be applied to assets in any active Shares currently using it." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Cancel button label */
                        cancel: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateSelector.deleteConfirmationDialog.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Delete button label */
                        delete: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateSelector.deleteConfirmationDialog.delete?c=7nzkz7owpk0x", defaultMessage: "Delete" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Label for accessing previously created templates */
            accessPreviouslyCreatedTemplates: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateSelector.accessPreviouslyCreatedTemplates?c=29y5meiufhzbl", defaultMessage: "Access previously created templates" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Notice about name and email */
            nameEmailNotice: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateSelector.nameEmailNotice?c=3ouuqc77gi29y", defaultMessage: "For signed out reviewers, Watermark will display the Share title and creator name in place of name and email." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for pending template search */
            searchPending: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateSelector.searchPending?c=2xzqohvscs9ht", defaultMessage: "Searching" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Placeholder for template search input */
            searchPlaceholder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateSelector.searchPlaceholder?c=1rrextlnfukzq", defaultMessage: "Search template" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
